import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedPslfDashboardRecommendationsController extends Controller {
  @tracked recommendation = '';

  queryParams = ['recommendation'];
}
